// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2-4Vj","name":"styles_name__12Nnk","phone":"styles_phone__3nEFb"};